module.exports = __webpack_public_path__ + "static/media/catalog-icon.57eae651.svg";